import { Box, Typography } from '@mui/material';
import Presentation1 from 'assets/Presentation1.webp';
import Presentation2 from 'assets/Presentation2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function PresentationDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Presentation" Chunk method description:</Typography>
      <Typography marginTop={2}>Supported file formats are {allowedFilesMap.naive.join(', ')}.</Typography>
      <Typography marginTop={3}>This method apply the naive ways to chunk files:</Typography>
      <ul>
        <li>Every page in the slides is treated as a chunk, with its thumbnail image stored.</li>
        <li>
          This chunk method is automatically applied to all uploaded PPT files, so you do not need to specify it
          manually.
        </li>
      </ul>
      <Typography fontWeight='500'>"Presentation" Examples</Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={Presentation1} alt='Presentation1' width={320} />
        <img src={Presentation2} alt='Presentation2' width={320} />
      </Box>
    </Box>
  );
}
